import React from 'react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

const MentalStatusSection = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <Label className="text-[#2A2C2A] font-medium">Mental Status</Label>
        <RadioGroup
          value={formData.mental_status}
          onValueChange={(v) => handleChange('mental_status', v)}
          className="grid grid-cols-2 sm:grid-cols-5 gap-2"
        >
          {['alert', 'depressed', 'obtunded', 'stuporous', 'comatose', 'unable_to_evaluate'].map(status => (
            <div key={status} className="flex items-center space-x-2">
              <RadioGroupItem value={status} id={status} data-testid={`mental-${status}`} />
              <Label htmlFor={status} className="capitalize text-sm">
                {status === 'unable_to_evaluate' ? 'Unable to Evaluate' : status}
              </Label>
            </div>
          ))}
        </RadioGroup>
      </div>
      <div className="space-y-2">
        <Label htmlFor="behavior" className="text-[#2A2C2A]">Behavior Notes</Label>
        <Textarea
          id="behavior"
          value={formData.behavior}
          onChange={(e) => handleChange('behavior', e.target.value)}
          placeholder="Describe any behavioral abnormalities (e.g., circling, head pressing, seizures)..."
          className="bg-[#F8F7F4] border-[#E5E4E0]"
          data-testid="behavior-notes"
        />
      </div>
    </div>
  );
};

export default MentalStatusSection;
